import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/core';
import { createPromoTeaserComponent } from '@vfde-brix/promo-teaser';

const mountPromoTeasers = (className: string) => {
    const promoTeasers = document.getElementsByClassName(className);

    for (const promoTeaserElement of Array.from(promoTeasers)) {
        mountPromoTeaser(promoTeaserElement.parentElement);
    }
};

/**
 * Mount single teaser
 * @param container
 */
export const mountPromoTeaser = (container: HTMLElement | null) => {
    container && createPromoTeaserComponent(container, NO_PATTERN_BUSINESS_LOGIC);
};

export default mountPromoTeasers;
